import React, { useEffect } from "react";
import Styles from "./ConGenMain.module.css";
import SelfHeader from "./HeadingElements/SelfHeader";
import SelfListing from "./ListingContainer/SelfListing/SelfListing";
import AvailableListingContainer from "./ListingContainer/AvailableListing/AvailableListingContainer";

const ConGenMain = () => {
  return (
    <div className={Styles.congenMainCont}>
      <div>
        <div className={Styles.elemHeader}>
          <SelfHeader />
        </div>
        <div className={`scroll_bar_x ${Styles.selfListingContainer}`}>
          <SelfListing />
        </div>
      </div>
      <div
        style={{
          maxHeight: "calc(100vh - 97px)",
          overflowY: "auto",
          position: "relative",
        }}
      >
        <AvailableListingContainer />
      </div>
    </div>
  );
};

export default ConGenMain;
